import React from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import CouponManagement from './components/CouponManagement';
import Login from './pages/Login';
import Home from './pages/Home';
import Sidebar from './components/Sidebar';
import AuthRoute from './components/AuthRoute';
import UserTestPage from './pages/UserTestPage';
import AdminUserManagement from './pages/AdminUserManagement';
import ResetPassword from './pages/ResetPassword';

const Dashboard = () => {
  return (
    <Layout>
      <Sidebar />
      <Layout>
        <Layout.Content>
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<AuthRoute />}>
          <Route path="/dashboard" element={<Dashboard />}>
            <Route index element={<Home />} />
            <Route path="coupons" element={<CouponManagement />} />
            <Route path="users" element={<AdminUserManagement />} />
            <Route path="user-test" element={<UserTestPage />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
